import { Box, CircularProgress } from '@mui/material';
import { useAppDispatch } from '../../../pages/assessment';
import { updateLandingRouter } from '../../../redux/assessment';
import useIsFirstRender from '../../hooks/useIsFirstRender';

const LandingRouter = () => {
  const dispatch = useAppDispatch();

  const isFirstRender = useIsFirstRender();
  if (isFirstRender) void dispatch(updateLandingRouter());

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height={200}
    >
      <CircularProgress />
    </Box>
  );
};

export default LandingRouter;
